var OCS = OCS || {};
OCS.UI = OCS.UI || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.EmbeddableUrl = new Class({
    Extends: OCS.WxBriefing.Classes.Panel,
    class_name: 'EmbeddableUrl',
    options: {
        container: null,
        template: 'object_embed'
    },
    render: function () {
        this.populate_panel();
        //this.frame_changed(null, new Date().getTime());
    },
    populate_panel: function () {
        this.parent();
        this.add_content();
        this.load_panel_options();
    },
    add_content: function () {
        var tm = OCS.WxBriefing.Functions.get_template_manager();
        var content = Elements.from(tm.get_html(this.options.template, {src: $.trim(OCS.WxBriefing.Live.UI.replace_url_template_text(this.get_product_content()))}));
        content.inject(this.options.container);
    },
    update_product: function () {
        this.unpopulate_panel();
        this.populate_panel();
    }
});